export const user = {
    id: 1,
    name: 'Peyton',
    isLimit: true,
    limitSec: 45,
    remaining: 45,
    // isRenew: true,
    // videos: {
    //     like: [{ videoId: 'v1' }, { videoId: 'v2' }],
    //     recommend: [{ videoId: 'v3' }, { videoId: 'v4' }]
    // }
};